// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgz_a big_vt big_ea big_a","MenuItem__Btn":"bgz_b big_z","MenuItem__subtitle":"bgz_c"};